import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../button/Button';
import './SectionModal.css';

interface SectionModalProps {
    isOpen: boolean;
    initialName?: string;
    onClose: () => void;
    onSave: (name: string) => void;
}

export const SectionModal: React.FC<SectionModalProps> = ({ isOpen, initialName = '', onClose, onSave }) => {
    const { t } = useTranslation();
    const [name, setName] = useState(initialName);

    useEffect(() => setName(initialName), [initialName, isOpen]);
    if (!isOpen) return null;

    const submit = () => {
        const trimmed = name.trim();
        if (trimmed) onSave(trimmed);
    };

    return (
        <div className="section-modal-overlay" onClick={onClose}>
            <div className="section-modal" onClick={(event) => event.stopPropagation()}>
                <h3>{initialName ? t('sections.renameSection') : t('sections.addSection')}</h3>
                <input
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                            submit();
                        }
                    }}
                    placeholder={t('sections.sectionNamePrompt')}
                    autoFocus
                />
                <div className="section-modal-actions">
                    <Button text={t('confirmationDialog.cancel')} status="secondary" type="" icon={undefined} onClick={onClose} />
                    <Button text={t('confirmationDialog.confirm')} status="" type="primary" icon={undefined} onClick={submit} />
                </div>
            </div>
        </div>
    );
};
